/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { createUltimatePagination } from 'react-ultimate-pagination';
import { formatClassName } from '../Util';
import Icon from './Icon';
import i18n from '../../src/i18n/translate';

const PaginationComponentButton = (props) => {
  const className = formatClassName({
    active: props.isActive,
    disabled: props.isDisabled,
    'arrow-button': props.isArrowButton
  });

  return (
    <li className={className} disabled={props.isDisabled}>
      <a role="button" onClick={props.onClick}>
        <span aria-label={props.label}>
          {props.value}
        </span>
      </a>
    </li>
  );
}
PaginationComponentButton.propTypes = {
  isActive: PropTypes.bool,
  isArrowButton: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.node
}

const PaginationComponentPage = (props) => PaginationComponentButton(props);

const PaginationComponentEllipsis = (props) => PaginationComponentButton({ ...props, isDisabled: true, onClick: null, value: "…", label: i18n.t("More") });

const PaginationComponentFirstPageLink = (props) => PaginationComponentButton({ ...props, isDisabled: props.isActive, isArrowButton: true, value: "«", label: i18n.t("First") });

const PaginationComponentPreviousPageLink = (props) => PaginationComponentButton({ ...props, isDisabled: props.isActive, isArrowButton: true, value: <Icon iconType="arrow-left" />, label: i18n.t("Previous") });

const PaginationComponentNextPageLink = (props) => PaginationComponentButton({ ...props, isDisabled: props.isActive, isArrowButton: true, value: <Icon iconType="arrow-right" />, label: i18n.t("Next") });

const PaginationComponentLastPageLink = (props) => PaginationComponentButton({ ...props, isDisabled: props.isActive, isArrowButton: true, value: "»", label: i18n.t("Last") });

const PaginationComponentWrapper = (props) => {
  const className = formatClassName([
    'pagination',
    { 'pagination-branded': props.isBranded }
  ]);

  return (
    <div className="pagination-wrapper">
      <div className={className}>{props.children}</div>
    </div>
  );
}
PaginationComponentWrapper.propTypes = {
  children: PropTypes.node,
  isBranded: PropTypes.bool
}

const itemTypeToComponent = {
  'PAGE': PaginationComponentPage,
  'ELLIPSIS': PaginationComponentEllipsis,
  'FIRST_PAGE_LINK': PaginationComponentFirstPageLink,
  'PREVIOUS_PAGE_LINK': PaginationComponentPreviousPageLink,
  'NEXT_PAGE_LINK': PaginationComponentNextPageLink,
  'LAST_PAGE_LINK': PaginationComponentLastPageLink
};

const UltimatePagination = createUltimatePagination({
  itemTypeToComponent,
  WrapperComponent: PaginationComponentWrapper
});

export default UltimatePagination;
